import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import '../wizards-manager/wizard-base/WizardSharedStyles.scss';

const ActivityEditableCell = ({
  value: initialValue,
  row: { index, state, setState, original },
  column: { id },
  updateDataFieldFromCell
}) => {
  useEffect(() => {
    if (!state.oldID || state.oldID !== original._id) {
      setState((s) => ({
        ...s,
        oldID: original._id,
        [id]: initialValue
      }));
    }
  }, [original._id, state[id]]);

  const editing = state.editing;
  const [value, setValue] = useState(initialValue);

  const onChange = useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const onBlur = useCallback(() => {
    updateDataFieldFromCell(index, id, value);
  }, [index, id, value]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <div className="wizard-input-container">
      {editing ? (
        <input
          type="text"
          className="the-field"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
      ) : (
        <>{value}</>
      )}
    </div>
  );
};

ActivityEditableCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired,
  updateDataFieldFromCell: PropTypes.func.isRequired
};

export default ActivityEditableCell;
